import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "Ana Sayfa", href: "#hero" },
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "Projeler", href: "#projeler" },
  { label: "Ekibimiz", href: "#ekip" },
  { label: "Hizmetler", href: "#hizmetler" },
  { label: "İletişim", href: "#iletisim" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: href } });
    } else {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      const el = document.querySelector("#hero");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <button onClick={handleLogoClick} className="flex items-center gap-3 cursor-pointer">
          <img
            src="/images/logo.png"
            alt="Güvenli Dizayn Logo"
            className={`h-12 w-auto object-contain transition-all duration-300 ${scrolled ? "" : "brightness-0 invert"}`}
          />
        </button>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? "text-[#2D3748] hover:text-[#4CAF50]"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>



        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex flex-col justify-center gap-1.5 cursor-pointer`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü"
        >
          <span className={`block h-0.5 w-6 transition-all duration-300 ${scrolled ? "bg-[#1A2B4A]" : "bg-white"} ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block h-0.5 w-6 transition-all duration-300 ${scrolled ? "bg-[#1A2B4A]" : "bg-white"} ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block h-0.5 w-6 transition-all duration-300 ${scrolled ? "bg-[#1A2B4A]" : "bg-white"} ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-white border-t border-gray-100 overflow-hidden transition-all duration-300 ${
          menuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className="text-sm font-medium text-[#2D3748] hover:text-[#4CAF50] text-left cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}

        </div>
      </div>
    </header>
  );
}
